import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * お支払い予定/履歴一覧
 *
 * お支払い予定/履歴データの一覧を返す
 */
export class FetchOrder implements APIRequest<Monitaro.FetchOrderResponse> {
  response: Monitaro.FetchOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/orders`
  }
}

/**
 * 指定されたオーダーを更新する
 *
 * UpdateOrderUseCaseを実行してオーダーを更新する
 */
export class PostOrder implements APIRequest<Monitaro.PostOrderResponse> {
  response: Monitaro.PostOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.UpdateOrderRequest
  constructor(params: Monitaro.UpdateOrderRequest) {
    this.params = params
    this.path = `/orders`
  }
}

/**
 * 最新の決済情報を更新する
 *
 * OrderUseCaseを実行して最新の決済情報を更新する
 */
export class PutOrder implements APIRequest<Monitaro.PutOrderResponse> {
  response: Monitaro.PutOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  constructor() {
    this.path = `/orders`
  }
}

/**
 * 指定された決済情報を取得
 *
 * 指定されたIDの決済情報を返す
 */
export class GetOrder implements APIRequest<Monitaro.GetOrderResponse> {
  response: Monitaro.GetOrderResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(order: string) {
    this.path = `/orders/${order}`
  }
}

/**
 * 指定されたオーダーの決済を実行する
 *
 * ExecuteUseCaseを実行して決済を実行する
 */
export class PostOrderExec implements APIRequest<Monitaro.PostOrderExecResponse> {
  response: Monitaro.PostOrderExecResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  constructor(order: string) {
    this.path = `/orders/exec/${order}`
  }
}
